/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 7th 2022, 7:17:12 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

enum Skeletons {
  container = "container",
  navBar = "navBar",
  content = "content",
}

type SkeletonStyles = { [key in keyof typeof Skeletons]: React.CSSProperties };

const styles: SkeletonStyles = {
  container: {},
  navBar: {},
  content: { padding: "30px 80px 0px 80px" },
};

export const ServiceBuilderSkeleton = () => (
  <Stack sx={styles.container}>
    <div style={styles.navBar}>
      <Skeleton animation="wave" variant="rectangular" height="10vh" sx={styles.navBar} />
    </div>
    <div style={styles.content}>
      <Skeleton animation="wave" variant="rectangular" height="80vh" />
    </div>
  </Stack>
);
